import { render, staticRenderFns } from "./CalleesPage.vue?vue&type=template&id=f95b6fb0&scoped=true"
import script from "./CalleesPage.vue?vue&type=script&lang=js"
export * from "./CalleesPage.vue?vue&type=script&lang=js"
import style0 from "./CalleesPage.vue?vue&type=style&index=0&id=f95b6fb0&prod&lang=scss&scoped=true"
import style1 from "./CalleesPage.vue?vue&type=style&index=1&id=f95b6fb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95b6fb0",
  null
  
)

export default component.exports